//development url: "http://localhost:3001/api"
//production url: "https://dxoe6pyyshl0b.cloudfront.net/api"

export const CONFIG = {
    API_URL: "https://dxoe6pyyshl0b.cloudfront.net/api",
    APP_NAME: "3D Simulator",
    IS_DEV: true
};